import React from 'react';

import { Button, Icon } from 'components/ui';
import { ButtonType } from 'components/ui/Button';
import type { Analytics } from 'hooks/useAnalytics';

const BUTTON_ICON_CLASSNAME = 'text-icon-3xl! text-btn-home-primary-text group-disabled:text-btn-home-primary-disabled-text! group-data-[fake-disabled=true]:text-btn-home-primary-disabled-text! sm:text-icon-xl!';
const BUTTON_CLASSNAME = 'group flex flex-col items-center justify-center h-full w-full filter-(--filter-btn-home-primary)! btn-home-primary rounded-soft-button! sm:flex-row sm:justify-start sm:gap-btn-home-primary-gap sm:p-btn-home-primary-mobile!';
const BADGE_CLASSNAME = 'flex justify-center sm:bg-btn-home-icon-badge-bg sm:group-disabled:bg-btn-home-icon-badge-disabled-bg sm:group-data-[fake-disabled=true]:bg-btn-home-icon-badge-disabled-bg mb-3 sm:rounded-btn-home-icon-badge sm:mb-0! sm:p-btn-home-icon-badge';

type HomeButtonProps = {
  icon: string;
  testId: string;
  disabled?: boolean;
  onClick: () => void;
  analytics: Analytics;
  label: React.ReactNode;
  disabledStyle?: boolean;
};

const HomeButton: React.FC<HomeButtonProps> = ({ icon, label, onClick, disabled, disabledStyle, testId, analytics }) => (
  <div className="flex flex-1 sm:flex-none sm:w-full">
    <Button
      testId={testId}
      onClick={onClick}
      disabled={disabled}
      analytics={analytics}
      type={ButtonType.PRIMARY}
      className={BUTTON_CLASSNAME}
      disabledStyle={disabledStyle}
    >
      <span className={BADGE_CLASSNAME}>
        <Icon className={`${icon} ${BUTTON_ICON_CLASSNAME}`} />
      </span>
      <span className="sm:whitespace-nowrap! text-btn-home-primary! [text-transform:var(--btn-home-primary-text-transform)]">{label}</span>
    </Button>
  </div>
);

export default HomeButton;
